import type { ColorByRule } from 'components/color-by-attribute-modal';

/**
 * The colour one well draws in, or null when no rule covers it.
 *
 * Rules are read in order and the last one with something to say wins, matching the
 * precedence the legend states. A rule that is disabled, aimed at another surface, or
 * missing this well's value says nothing, leaving the surface's own default.
 * @param {ColorByRule[]} rules The rail's rules.
 * @param {string} target The surface asking (a key of the rule's `applyTo`).
 * @param {Record<string, string | null | undefined>} attributes The well's values, keyed
 *   by the same attribute ids the rules use.
 * @return {string | null} The colour, or null to leave the surface's own default.
 */
export const resolveWellColor = (
  rules: ColorByRule[],
  target: string,
  attributes: Record<string, string | null | undefined>
): string | null => {
  let color: string | null = null;

  rules
    .filter((rule) => rule.enabled && rule.applyTo[target])
    .forEach((rule) => {
      const value = attributes[rule.attribute];
      if (!value || !rule.selectedValues.includes(value)) return;

      const chosen = rule.valueColors[value];
      if (chosen) color = chosen;
    });

  return color;
};
